import { SvgIcon } from "@mui/material";
import { SiTiktok } from "react-icons/si";

const TikTokIcon = (props) => {
  return <SvgIcon {...props} component={SiTiktok} inheritViewBox />;
};

export default TikTokIcon;
